import $              from 'jquery';
import 'mediaelement/full';
import Top            from './blocks/top';
import Carousel       from './blocks/carousel';
import Performance    from './blocks/performance';
import Testimonials   from './blocks/testimonials';
import Academics      from './blocks/academics';
import News           from './blocks/news';
import Courses        from './blocks/courses';
import Feed           from './blocks/feed';
import Notes          from './blocks/notes';
import Subpages       from './blocks/subpages';
import Bricks         from './blocks/bricks';
import Filters        from './blocks/filters';
import Form           from './blocks/form';
import Listing        from './blocks/listing';
import Topics         from './blocks/topics';
import Toast          from './components/toast';
import Accordion      from './components/accordion';
import VideoLink      from './components/video-link';
import ImageGrid      from './components/image-grid';
import Input          from './components/input';
import Modal          from './components/modal';
import Select         from './components/select';
import Cms            from './containers/cms';
import EbscoForm      from './containers/ebscoForm';
import LinkTracker    from './components/link-tracker';
import CookieConsent from './components/cookie-consent';

$(document).ready(() => {
    $('.top').each((i, el) => { new Top($(el)); });
    $('.carousel').each((i, el) => { new Carousel($(el)); });
    $('.performance').each((i, el) => { new Performance($(el)); });
    $('.testimonials').each((i, el) => { new Testimonials($(el)); });
    $('.academics').each((i, el) => { new Academics($(el)); });
    $('.news').each((i, el) => { new News($(el)); });
    $('.courses').each((i, el) => { new Courses($(el)); });
    $('.feed').each((i, el) => { new Feed($(el)); });
    $('.notes').each((i, el) => { new Notes($(el)); });
    $('.subpages').each((i, el) => { new Subpages($(el)); });
    $('.bricks').each((i, el) => { new Bricks($(el)); });
    $('.filters').each((i, el) => { new Filters($(el)); });
    $('.form').each((i, el) => { new Form($(el)); });
    $('.listing').each((i, el) => { new Listing($(el)); });
    $('.topics').each((i, el) => { new Topics($(el)); });
    $('.toast').each((i, el) => { new Toast($(el)); });
    $('.accordion').each((i, el) => { new Accordion($(el)); });
    $('.video-link,.video-link--no-icon').each((i, el) => { new VideoLink($(el)); });
    $('.image-grid').each((i, el) => { new ImageGrid($(el)); });
    $('.input').each((i, el) => { new Input($(el)); });
    $('.modal').each((i, el) => { new Modal($(el)); });
    $('.select').each((i, el) => { new Select($(el)); });
    $('.cms').each((i, el) => { new Cms($(el)); });
    $('.ebscoSearchForm').each((i, el) => { new EbscoForm($(el)); });
    new LinkTracker($('html'));
    new CookieConsent();

});